import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { JudgeScoresInfo } from '../../application/application.service';

@Component({
    selector: 'dialog-tieoverride-component',
    templateUrl: 'tieoverride.dialogcomponent.html',
    styleUrls: ['tieoverride.dialogcomponent.scss']
})

export class TieOverrideDialogComponent implements OnInit, OnDestroy {
    private _subrelease: Subject<void> = new Subject<void>();
    Nominees: JudgeScoresInfo[];
    TieForm: FormGroup;
    DuplicateRank: number;
    AvailableRanks: number[];

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogRef: MatDialogRef<TieOverrideDialogComponent>,
        private fb: FormBuilder) { }

    ngOnInit() {
        this.Nominees = this.data.Options.tiedNominees;
        this.AvailableRanks = [];

        for (let i = 1; i <= this.Nominees.length; i++) {
            this.AvailableRanks.push(i);
        }

        this.TieForm = this.fb.group({
            RankingsList: this.fb.array([])
        });

        let rankingsArray = this.TieForm.get('RankingsList') as FormArray;
        for (let nom of this.Nominees) {
            rankingsArray.push(this.CreateRankingDetailFormGroup(nom.NominationID));
        }

        rankingsArray.valueChanges.pipe(takeUntil(this._subrelease)).subscribe((vals: any[]) => {
            let ranks = vals.map(m => m.Rank);
            this.DuplicateRank = ranks.find((v, i) => ranks.findIndex(x => x === v) !== i);
        });
    }

    ngOnDestroy() {
        this._subrelease.next();
        this._subrelease.complete();
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

    CreateRankingDetailFormGroup(id: number): FormGroup {
        return this.fb.group({
            NomID: id,
            Rank: [null, Validators.required]
        });
    }

    DuplicateExists(index: number): boolean {
        if (this.DuplicateRank != null) {
            if (this.TieForm.value.RankingsList[index].Rank === this.DuplicateRank) {
                return true;
            }
        }
        return false;
    }

    Submit(form: FormGroup) {
        if (form.invalid || this.DuplicateRank != null) {
            return;
        }

        for (let f of form.value.RankingsList) {
            this.Nominees.find(n => n.NominationID === f.NomID).SelectedRanking = f.Rank;
        }

        this.dialogRef.close(this.Nominees);
    }
}

export class BaseTieOverrideDialogOptions {
    tiedNominees: JudgeScoresInfo[];
}
